import { render, staticRenderFns } from "./Foot1024.vue?vue&type=template&id=d6a3d0c8&scoped=true"
import script from "./Foot1024.vue?vue&type=script&lang=js"
export * from "./Foot1024.vue?vue&type=script&lang=js"
import style0 from "./Foot1024.vue?vue&type=style&index=0&id=d6a3d0c8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a3d0c8",
  null
  
)

export default component.exports